import React from 'react';
import s from '../Login.module.scss';
const LoginMethodWithTitle = ({ children, title }) => (React.createElement("div", { className: s.loginMethodWrapper },
    React.createElement("h3", { className: s.loginMethodTitle }, title),
    children));
export default LoginMethodWithTitle;
